import { Component } from '@angular/core';

@Component({
  selector: 'app-list-votes',
  templateUrl: './list-votes.component.html',
  styleUrl: './list-votes.component.scss'
})
export class ListVotesComponent {
  votes = [
    { numero: 12345, descripcion: 'Revisión de gastos generales', empleado: 'Juan Pérez', periodo: '2023-01' },
    { numero: 67890, descripcion: 'Informe de auditoría interna', empleado: 'María López', periodo: '2023-02' },
    { numero: 11223, descripcion: 'Planificación de recursos', empleado: 'Carlos Ruiz', periodo: '2023-03' },
    { numero: 44556, descripcion: 'Evaluación de desempeño', empleado: 'Ana Gómez', periodo: '2023-04' },
    { numero: 78901, descripcion: 'Gestión de proyectos', empleado: 'Luis Fernández', periodo: '2023-05' }
  ];
}
